export default {
    employeeManagement: 'Employee management',
    importEmployeeList: 'Import Employee list',
    sync: 'Sync Employee Data',
    employeeList: 'Employee list',
    employeeImage: 'Employee Image'
}
